import styled, { css } from 'styled-components';

import { Stepper } from 'components/stepper';

export const StyledStepper = styled(Stepper)`
  flex: unset;
`;

export const FormContainer = styled.div`
  flex: 1;
  display: flex;
  overflow-y: auto;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  ${({ theme }) =>
    !theme.responsive.isMobile &&
    css`
      > button {
        min-width: 136px;
      }
    `}
`;
